module.exports = __webpack_public_path__ + "static/media/DSLogo.aff56d42.webp";